"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @module Model/Seeding
 */
var SeedingError;
(function (SeedingError) {
    SeedingError["database_operation_failed"] = "database_operation_failed";
    SeedingError["invalid_parameters"] = "invalid_parameters";
})(SeedingError = exports.SeedingError || (exports.SeedingError = {}));
//# sourceMappingURL=seeding.js.map


//////////////////
// WEBPACK FOOTER
// ./lib/model/seeding.js
// module id = 230
// module chunks = 0